export default __webpack_public_path__ + "static/media/place.93ab3e14.svg";